// Prompt AC CAMBIO 2 (2026-09-21): "Client Note" — siempre visible, FUERA de
// las pestañas Details/Files/Notes, así como en los mockups del permiso y de
// Site Inspection. Componente controlado simple: cada pagina decide si
// guarda al vuelo (onBlur) o via su propio boton Save existente.
import { Card, CardContent } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { MessageSquare } from 'lucide-react';

export default function ClientNoteCard({ value, onChange, onBlur, placeholder = 'Add a note...', maxLength = 500, testId = 'client-note-card', title = 'Client Note', icon: Icon = MessageSquare }) {
  const text = value || '';
  return (
    <Card className="bg-white border-gray-100" data-testid={testId}>
      <CardContent className="p-3 space-y-1.5">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4 text-blue-500" />
          <span className="text-xs uppercase tracking-wide text-gray-400 font-semibold">{title}</span>
        </div>
        <Textarea
          value={text}
          onChange={e => onChange(e.target.value.slice(0, maxLength))}
          onBlur={onBlur}
          placeholder={placeholder}
          rows={3}
          className="text-sm"
          data-testid={`${testId}-textarea`}
        />
        <p className="text-[11px] text-gray-400 text-right" data-testid={`${testId}-counter`}>{text.length} / {maxLength}</p>
      </CardContent>
    </Card>
  );
}
